/*
 * Author: Nirjhor
 * Title: D1 Form: In-memory requisition store
 * Description: Module-level store so typing into the editable grid does not
 *              trigger React re-renders. Backend payload shape is unchanged
 *              (array of { drug_id, req_qty, remarks, ...item }).
 * Date: 16/08/2026
 */

const store = {};

export const setReq = (drugId, field, value, item) => {
  if (value === "" || value === null || typeof value === "undefined") {
    if (store[drugId]) {
      delete store[drugId][field];
      if (Object.keys(store[drugId]).length === 0) {
        delete store[drugId];
      }
    }
  } else {
    const saved = store[drugId] || {};
    store[drugId] = { ...item, ...saved, [field]: value };
  }
};

export const getReq = (drugId) => store[drugId] || {};

export const getAllReq = () => Object.values(store);

export const clearReq = () => {
  Object.keys(store).forEach((key) => delete store[key]);
};

export const loadReq = (list) => {
  clearReq();
  (list || []).forEach((item) => {
    const drugId = item?.drug_id ?? item?.id;
    if (drugId) {
      store[drugId] = { ...item };
    }
  });
};
